<template>
  <SAIPageWrapper>
    <SAITitle>Email Sent!</SAITitle>
    <div class="row justify-center q-py-lg">
      <QImg
        :src="image"
        style="min-width: 300px"
        class="col-lg-3 col-md-4 col-sm-6 col-xs-9"
        spinner-color="primary"
      />
    </div>
    <div class="q-py-sm text-center">
      <p>
        Now we just wait for your Employer to approve your quote. To speed up
        the process please feel free to contact your employer to approve the
        request.
      </p>
    </div>
  </SAIPageWrapper>
</template>

<script>
import { QImg } from 'quasar';
import { SAITitle, SAIPageWrapper } from 'ecx.saigon.ui.common';

export default {
  name: 'HrApprovalSentPage',
  props: {
    image: String
  },
  components: {
    QImg,
    SAITitle,
    SAIPageWrapper
  }
};
</script>
